import { TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';
import { TShopItem, TTariff } from 'types';
import { assumeDuration, formatTariffTime } from 'utils';

const isLastTariff = (items: Array<TShopItem>, index: number): boolean =>
  !items.slice(index + 1).some((item) => item.type === 'TARIFF');

const getTariffDuration = (
  tariff: TTariff,
  t: TTranslator<TLocalesKeys>
): string | undefined => {
  if (tariff.has_fixed_finish_time) {
    const start = formatTariffTime(tariff.time_from);
    let end = formatTariffTime(tariff.time_to);

    if (end.isBefore(start)) {
      end = end.add(1, 'day');
    }

    const secondsDiff = end.diff(start, 'seconds');

    return assumeDuration(secondsDiff, t)?.title;
  }

  return assumeDuration(tariff.duration, t)?.title;
};

export { getTariffDuration, isLastTariff };
